import gql from "graphql-tag";

export const PREPARE_UPLOAD_DATA = gql`
  mutation PrepareUploadData($base64File: String!, $hasHeader: Boolean!) {
    prepareUploadData(base64File: $base64File, hasHeader: $hasHeader) {
      jsonData
    }
  }
`;
export const INSERT_UPLOAD_DATA = gql`
  mutation InsertUploadData(
    $utilisateurId: Int!
    $dataSourceId: String!
    $data: JSONObject!
  ) {
    insertUploadData(
      utilisateurId: $utilisateurId
      dataSourceId: $dataSourceId
      data: $data
    ) {
      type
      message
      details
    }
  }
`;
export const CREATE_DATA_SOURCE = gql`
  mutation createDataSource(
    $dataSourceName: String!
    $utilisateurId: Int!
    $balance: Float
  ) {
    createDataSource(
      dataSourceName: $dataSourceName
      utilisateurId: $utilisateurId
      balance: $balance
    ) {
      type
      message
      details
    }
  }
`;
